import { Component, HostListener, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common'
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatSelectModule } from '@angular/material/select';
import { MatRadioModule } from '@angular/material/radio';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { Router } from '@angular/router';
import { APIService } from '../backend-service/backend-service';
import { environment } from '../../../environments/environment';
import { SharedService } from '../../share-data/shared.service';
import { GlobalVariablesService } from '../../global.service';
import { NotificationService } from '../../shared/services/notification.service';
import { LoadingService } from '../../services/loading.service';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogComponent } from '../transport-management/confirm-dialog/confirm-dialog.component';
import { Subscription } from 'rxjs';
import { PhoneFormatPipe } from '../../shared/pipes/phone-format.pipe';


@Component({
  selector: 'app-truck-profile',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    FormsModule,
    MatCheckboxModule,
    MatInputModule,
    CommonModule,
    MatChipsModule,
    MatSelectModule,
    MatFormFieldModule,
    MatAutocompleteModule,
    MatIconModule,
    MatRadioModule,
    MatProgressSpinnerModule,
    PhoneFormatPipe
  ],
  templateUrl: './truck-profile.component.html',
  styleUrl: './truck-profile.component.scss'
})
export class TruckProfileComponent implements OnDestroy {
  searchText: string = '';
  datas: any[] = [];
  truckData: any[] = [];
  currentPage: number = 1;
  totalPages: number = 1;
  pageSize: number = 10;
  pages: number[] = [];
  selectedTruckId: string | null = null;
  dropdownPosition = { top: '0px', right: '0px' };
  isLoading: boolean = false;
  private loadingSubscription: Subscription;

  constructor(private router: Router, private apiService: APIService, private sharedService: SharedService,
    private globalVariable: GlobalVariablesService,
    private notification: NotificationService,
    public loadingService: LoadingService,
    private dialog: MatDialog) {
    this.loadingSubscription = this.loadingService.isLoading$.subscribe(loading => this.isLoading = loading);
  }

  ngOnInit() {
    this.getTruckList();
    // this.datas = [
    //   { plateNumber: '2S-7035 (Phnom Pehn)', truckType: 'Nissan', contactName: 'Meas Bora', photo: 'assets/img/truck.png', phoneNumber: '0969876543' },
    //   { plateNumber: '2AD-3366 (Phnom Pehn)', truckType: 'Hyundai', contactName: 'Hok Sok', photo: 'assets/img/truck.png', phoneNumber: '012345678' },
    //   { plateNumber: '2BA-6939 (Phnom Pehn)', truckType: 'Hyundai', contactName: 'Sin Vey', photo: 'assets/img/truck.png', phoneNumber: '0975556666' },
    // ];
  }
  addNewTruck() {
    this.router.navigate(['/home/truck-profile/registration']);
  }
  getTruckList(page: number = 1) {
    this.datas = [];
    let loginData = JSON.parse(localStorage.getItem('loginData')!)
    console.log("LoginData: ", loginData)
    this.apiService.get(`/api/trucks?page=${page}&limit=${this.pageSize}`, loginData.token).subscribe({
      next: (response) => {
        console.log('Status:', response.status);
        console.log('/api/truck/list' + ',\n' + 'Truck_List_Response:', response.body.trucks);
        if (response.status === 200) {
          response.body.trucks.forEach((data: { [x: string]: any; }) => {
            try {
              // this.datas.push({
              //   photo: environment.imageUrl + data["picture"],
              //   plateNumber: data['plateNumber'],
              //   contactName: `${data['contactName'] ? data['contactName'] : ''}`,
              //   truckType: `${data['truckType'] ? data['truckType'] : ''}`,
              //   phoneNumber: data['contactPrimaryNumber'] ? data['contactPrimaryNumber'] : data['contactSecondayNumber']
              //   ,
              // })
              console.log("TruckType: ", this.globalVariable.SETTING_TRUCK_TYPES.find((obj: any) => obj.id === data["truckType"]) || { id: '', name: '' })
              this.datas.push({
                ...data,
                photo: environment.imageUrl + data["picture"],
                profilePictureUrl: data["profilePicture"] ? environment.imageUrl + data["profilePicture"] : null,
                status: data["status"] || 'ACTIVE',
                truckTypeValue: this.globalVariable.SETTING_TRUCK_TYPES.find((obj: any) => obj.id === data["truckTypeId"]) || { id: '', name: '' }
              })
              console.log("this.datas: ", this.datas)
            } catch (error) {

            }
          });
          this.totalPages = response.body.pagination.totalPages;
          this.pages = Array(this.totalPages).fill(0).map((_, i) => i + 1);
          this.currentPage = page;
        }
        else {
          console.log("Hey you")
        }
      },
      error: (error) => {
        console.error('Error status:', error.status);
        console.error('Error message:', error.message);
      }
    });
  }

  get filteredOrders() {
    if (!this.searchText) {
      return this.datas;
    }
    const searchLower = this.searchText.toLowerCase();
    return this.datas.filter(data => {
      const plateNumber = data.plateNumber?.toLowerCase() || '';
      const contactName = data.contactName?.toLowerCase() || '';
      const phoneNumber = data.contactPrimaryNumber || '';
      return plateNumber.includes(searchLower) ||
        contactName.includes(searchLower) ||
        phoneNumber.includes(this.searchText);
    });
  }

  get pagedOrders() {
    return this.filteredOrders;
  }

  editTruck(data: any, event: MouseEvent) {
    console.log("Selected Id: ", data.id)
    if (this.selectedTruckId === data.id) {
      this.selectedTruckId = null;
    } else {
      const btn = event.currentTarget as HTMLElement;
      const rect = btn.getBoundingClientRect();
      const rightOffset = window.innerWidth - rect.right;
      this.dropdownPosition = {
        top: `${rect.bottom + 4}px`,
        right: `${Math.max(rightOffset, 8)}px`,
      };
      this.selectedTruckId = data.id;
    }
  }
  onEdit(data: any) {
    this.selectedTruckId = null;
    this.sharedService.setData(data);
    this.router.navigate(
      ['/home/truck-profile/registration/:id'],
      { queryParams: { isEdit: true } }
    );
  }
  onDelete(data: any) {
    this.selectedTruckId = null;
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '420px',
      data: { plateNumber: data.plateNumber, title: 'Delete Truck', confirmLabel: 'Delete', message: 'Are you sure you want to delete truck' }
    });
    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        this.deleteCustomer(data);
      }
    });
  }
  truckStatuses = [
    { value: 'ACTIVE', label: 'Active' },
    { value: 'INACTIVE', label: 'Inactive' },
    { value: 'IN_SHOP', label: 'In Shop' },
    { value: 'OUT_OF_SERVICE', label: 'Out of Service' },
  ];

  updateTruckStatus(data: any, status: string): void {
    const previous = data.status;
    data.status = status;
    let loginData = JSON.parse(localStorage.getItem('loginData')!);
    this.apiService.put(`/api/trucks/${data.id}/status`, { status }, loginData.token).subscribe({
      next: (response) => {
        if (response.status === 200 || response.status === 201) {
          this.notification.success(`Truck status updated to ${status}`);
        } else {
          data.status = previous;
          this.notification.error('Failed to update status. Please try again.');
        }
      },
      error: () => {
        data.status = previous;
        this.notification.error('Failed to update status. Please try again.');
      }
    });
  }

  deleteCustomer(data: any) {
    let loginData = JSON.parse(localStorage.getItem('loginData')!)
    this.apiService.delete('/api/trucks/' + data.id, loginData.token).subscribe({
      next: (response) => {
        console.log('Status:', response.status);
        console.log('/api/trucks/delete' + ',\n' + 'Truck_Delete_Response:', response);
        this.notification.success(response.message || 'Operation completed successfully');
        this.getTruckList();
      },
      error: (error) => {
        console.error('Error status:', error.status);
        console.error('Error message:', error.message);
      }
    });
  }

  ngOnDestroy() {
    if (this.loadingSubscription) {
      this.loadingSubscription.unsubscribe();
    }
  }

  @HostListener('document:click', ['$event'])
  handleClickOutside(event: MouseEvent) {
    const target = event.target as HTMLElement;

    // Only close the dropdown if clicked outside any dropdown-related button or menu
    if (!target.closest('.btn-icon-action') && !target.closest('.dropdown-menu')) {
      this.selectedTruckId = null;
    }
  }
}
